import { Group, Paper, Title } from '@mantine/core';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import PratiquesTable from '../../components/tables/pratiques-table';

import { FullMainHeight } from '@ui';

export const PratiquesPage: FC = () => {
  const { t } = useTranslation();

  return (
    <FullMainHeight.Root>
      <FullMainHeight.Header>
        <Paper>
          <Group justify="space-between">
            <Title order={2}>{t('app.nav.pratiques')}</Title>
          </Group>
        </Paper>
      </FullMainHeight.Header>
      <FullMainHeight.Content>
        <PratiquesTable />
      </FullMainHeight.Content>
    </FullMainHeight.Root>
  );
};
